/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import GradientBorder from "~components/GradientBorder";
import Bag from "~components/svg/Bag";
import Search from "~components/svg/Search";
import Wordmark from "~components/svg/Wordmark";
import { sortArrayByPriority } from "~utils/helpers";

const Header = () => {
  const {
    cart,
    cartItemAdded,
    setContactLink,
    menuActive,
    setMenuActive,
    notificationActive,
    pathname
  } = useContext(AppContext);
  const { device, scrollTop, windowWidth } = useContext(DocumentContext);

  const [menuHovering, setMenuHovering] = useState(false);
  const [transparent, setTransparent] = useState(false);

  const { allSanityCollection, sanityServices } = useStaticQuery(graphql`
    query Header {
      allSanityCollection {
        edges {
          node {
            handle
            title
            priority
          }
        }
      }

      sanityServices {
        promotions {
          title
        }
      }
    }
  `);

  //

  let cartCount = 0;

  if (cart?.[0]) {
    cart.forEach(cartItem => {
      cartCount += cartItem.quantity;
    });
  }

  let backgroundColor = `bone`;
  let foregroundColor = `black`;

  switch (pathname) {
    case `/careers`:
    case `/careers/`:
    case `/contact`:
    case `/contact/`:
    case `/services`:
    case `/services/`:
      backgroundColor = `scarlet`;
      foregroundColor = `bone`;

      break;

    case `/collections`:
    case `/collections/`:
      backgroundColor = `bone`;
      foregroundColor = `black`;

      break;

    case `/`:
    default:
      break;
  }

  if (menuActive) {
    backgroundColor = `scarlet`;
    foregroundColor = `bone`;
  }

  //

  useEffect(() => {
    setTransparent(pathname === `/` || pathname?.includes(`/joey-loves`));
  }, [pathname]);

  useEffect(() => {
    if (scrollTop < 100 || !pathname || pathname !== `/`) {
      return;
    }

    if (
      (windowWidth < 1440 && scrollTop < windowWidth * 0.5) ||
      (windowWidth >= 1440 && scrollTop < 660)
    ) {
      if (!transparent) {
        setTransparent(true);
      }
    } else if (transparent) {
      setTransparent(false);
    }
  }, [scrollTop]);

  //

  const collections = [];

  if (allSanityCollection?.edges?.[0]) {
    allSanityCollection.edges.forEach(({ node }) => {
      collections.push(node);
    });
  }

  sortArrayByPriority(collections);

  //

  return (
    <>
      {(device === `desktop` && (
        <header
          className={`header ${
            notificationActive ? `notification-active` : ``
          } w-full fixed top-0 right-0 left-0 z-30 pt-v1 pb-v1 bg-${
            !menuHovering && transparent ? `transparent` : backgroundColor
          } text-${!menuHovering && transparent ? `bone` : foregroundColor}`}
        >
          {!transparent && (
            <GradientBorder
              color={backgroundColor === `scarlet` ? `red` : `shampoo`}
            />
          )}

          <nav className="animation-appear-down grid unbound z-10">
            <ul className="grid-end-4 relative z-10 flex items-center justify-between pr-v10">
              <li
                className="header__hoverable relative f4 uppercase"
                onMouseEnter={() => setMenuHovering(true)}
                onMouseLeave={() => setMenuHovering(false)}
              >
                <Link
                  to="/collections"
                  className={`hover-underline relative z-10 ${
                    pathname.includes(`/brands`) ||
                    pathname.includes(`/collections`)
                      ? `underline`
                      : ``
                  }`}
                >
                  SHOP
                </Link>

                <ul
                  className={`header__menu absolute top-0 left-0 pl-v1 pr-v1 bg-${backgroundColor}`}
                >
                  {collections?.[0] &&
                    collections.map(collection => {
                      const key = collection.handle;

                      return (
                        <li
                          key={key}
                          className={`header__menu__link whitespace-no-wrap hover-underline f4 ${
                            pathname === `/collections/${collection.handle}`
                              ? `underline`
                              : ``
                          } uppercase text-${foregroundColor}`}
                        >
                          <Link
                            to={`/collections/${collection.handle}`}
                            className="block pt-v05 p-v05"
                          >
                            {collection.title}
                          </Link>
                        </li>
                      );
                    })}

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link
                      to="/brands"
                      className={`${
                        pathname === `/brands` ? `underline` : ``
                      } block pt-v05 p-v05`}
                    >
                      Shop Brands
                    </Link>
                  </li>

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link
                      to="/collections"
                      className={`${
                        pathname === `/collections` ? `underline` : ``
                      } block pt-v05 p-v05`}
                    >
                      Shop All
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className="header__hoverable relative f4 uppercase"
                onMouseEnter={() => setMenuHovering(true)}
                onMouseLeave={() => setMenuHovering(false)}
              >
                <Link
                  to="/contact"
                  className={`hover-underline relative z-10 ${
                    pathname === `/contact` ? `underline` : ``
                  }`}
                >
                  Contact
                </Link>

                <ul
                  className={`header__menu absolute top-0 left-0 pl-v1 pr-v1 bg-${backgroundColor}`}
                >
                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link
                      to="/contact"
                      onClick={e => {
                        if (
                          pathname === `/contact` ||
                          pathname === `/contact/`
                        ) {
                          e.preventDefault();
                        }

                        setContactLink(`bookings`);
                      }}
                    >
                      Bookings
                    </Link>
                  </li>

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link
                      to="/contact"
                      onClick={e => {
                        if (
                          pathname === `/contact` ||
                          pathname === `/contact/`
                        ) {
                          e.preventDefault();
                        }

                        setContactLink(`opening`);
                      }}
                    >
                      Opening hours
                    </Link>
                  </li>

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link
                      to="/contact"
                      onClick={e => {
                        if (
                          pathname === `/contact` ||
                          pathname === `/contact/`
                        ) {
                          e.preventDefault();
                        }

                        setContactLink(`visit`);
                      }}
                    >
                      Visit us
                    </Link>
                  </li>

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link to="/careers">Careers</Link>
                  </li>

                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link to="/mt-buller">MT BULLER</Link>
                  </li>
                </ul>
              </li>

              <li
                className="header__hoverable relative f4 uppercase"
                onMouseEnter={() => setMenuHovering(true)}
                onMouseLeave={() => setMenuHovering(false)}
              >
                <Link
                  to="/services"
                  className={`hover-underline relative z-10 ${
                    pathname === `/services` ? `underline` : ``
                  }`}
                >
                  Services
                </Link>

                <ul
                  className={`header__menu absolute top-0 left-0 pl-v1 pr-v1 bg-${backgroundColor}`}
                >
                  <li
                    className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                  >
                    <Link to="/services#price-list">Price list</Link>
                  </li>

                  {sanityServices?.promotions?.[0] &&
                    sanityServices.promotions.map(promotion => {
                      const promotionId = promotion.title
                        .toLowerCase()
                        .replace(/ /g, `-`);

                      return (
                        <li
                          key={`header-promotion-${promotionId}`}
                          className={`header__menu__link whitespace-no-wrap hover-underline f4 uppercase text-${foregroundColor}`}
                        >
                          <Link to={`/services#${promotionId}`}>
                            {promotion.title}
                          </Link>
                        </li>
                      );
                    })}
                </ul>
              </li>
            </ul>

            {/* // */}

            <div className="grid-end-4 relative z-10 flex items-center justify-center text-center">
              <Link to="/">
                <Wordmark
                  className="animation-appear-down-slow animation-delay-3 header__wordmark w-v24 relative block cursor-pointer"
                  color={
                    backgroundColor === `scarlet` ||
                    (transparent && !menuHovering)
                      ? `bone`
                      : `black`
                  }
                />
              </Link>
            </div>

            {/* // */}

            <ul className="grid-end-4 relative z-10 flex items-center justify-between pl-v3">
              <li className="f4 uppercase">
                <Link
                  to="/joey-loves"
                  className={`hover-underline relative z-10 ${
                    pathname === `/joey-loves` ? `underline` : ``
                  }`}
                >
                  JOEY LOVES
                </Link>
              </li>

              <li className="f4 uppercase">
                <Link
                  to="/about"
                  className={`hover-underline relative z-10 ${
                    pathname === `/about` ? `underline` : ``
                  }`}
                >
                  ABOUT
                </Link>
              </li>

              <li className="relative">
                <Link
                  to="/bag"
                  className={`hover-underline relative z-10 ${
                    pathname === `/bag` ? `underline` : ``
                  }`}
                >
                  <p className="f4 uppercase">Bag ({cartCount})</p>
                </Link>

                <div
                  className={`header__cart-widget ${
                    cartItemAdded ? `active` : ``
                  } h-10 absolute z-10 flex items-center justify-center pointer-events-none bg-shampoo f4`}
                >
                  <span className="b2 text-orange text-center">
                    added to bag
                  </span>
                </div>
              </li>

              <li className="relative">
                <Link to="/search">
                  <Search
                    className="w-4"
                    color={
                      backgroundColor === `scarlet` || transparent
                        ? `bone`
                        : `black`
                    }
                  />
                </Link>
              </li>
            </ul>

            {/* // */}

            {(pathname === `/collections` || pathname === `/collections/`) && (
              <ul className="animation-appear-down-slow animation-delay-2 grid-end-10 grid-start-2 relative pt-v1 flex justify-between">
                {collections?.[0] &&
                  collections.map(collection => {
                    const key = collection.handle;

                    return (
                      <li key={key}>
                        <Link
                          className="pt-v05 block hover-underline b2 text-center"
                          to={`/collections/${collection.handle}`}
                        >
                          {collection.title}
                        </Link>
                      </li>
                    );
                  })}
              </ul>
            )}
          </nav>
        </header>
      )) || (
        <header
          className={`header header--touch ${
            notificationActive ? `notification-active` : ``
          } w-full h-12 fixed top-0 right-0 left-0 z-30 flex items-center justify-center bg-${
            !menuHovering && transparent ? `transparent` : backgroundColor
          } text-${!menuHovering && transparent ? `bone` : foregroundColor}`}
        >
          {!transparent && !menuActive && (
            <GradientBorder
              color={backgroundColor === `scarlet` ? `red` : `shampoo`}
            />
          )}

          <nav className="grid">
            <div className="grid-end-2 flex">
              <button
                className="w-1/2 relative block pr-1"
                type="button"
                onClick={() => setMenuActive(!menuActive)}
              >
                <div
                  className={`header__burger ${
                    menuActive ? `active` : ``
                  } w-full h-full relative flex flex-col items-center justify-center pb-1`}
                >
                  <div className="header__burger__line header__burger__line--0 w-full relative block mt-1 border-t"></div>
                  <div className="header__burger__line header__burger__line--1 w-full relative block mt-1 border-t"></div>
                  <div className="header__burger__line header__burger__line--2 w-full relative block mt-1 border-t"></div>
                </div>
              </button>
            </div>

            <Link to="/" className="grid-end-8">
              <Wordmark
                className="header--touch__logo animation-appear-down-slow animation-delay-3 w-full relative block mx-auto"
                color={
                  backgroundColor === `scarlet` || transparent
                    ? `bone`
                    : `black`
                }
              />
            </Link>

            <div className="grid-end-2 relative flex items-center justify-end">
              <Link
                to="/bag"
                className={`hover-underline relative z-10 ${
                  pathname === `/bag` ? `underline` : ``
                }`}
              >
                {cartCount > 0 && (
                  <div className="animation-pop-slow w-4 h-4 absolute top-0 right-0 flex items-center justify-center -mt-2 -mr-2 rounded-full bg-orange text-bone caption">
                    <span
                      className="caption"
                      style={{ fontSize: `8px`, lineHeight: 1 }}
                    >
                      {cartCount}
                    </span>
                  </div>
                )}

                <Bag
                  className="w-5"
                  color={
                    backgroundColor === `scarlet` || transparent
                      ? `bone`
                      : `black`
                  }
                />
              </Link>

              <div
                className={`header__cart-widget ${
                  cartItemAdded ? `active` : ``
                } h-10 absolute right-0 top-0 z-10 flex items-center justify-center -ml-4 pointer-events-none bg-shampoo f4`}
              >
                <span className="b2 text-orange text-center">added to bag</span>
              </div>
            </div>
          </nav>
        </header>
      )}
    </>
  );
};

export default Header;
